<template>
    <div class="wd-100p ht-100p">
        <Header></Header>
        <div class="pos-r" v-animate="{ name: 'bounceInLeft', delay: 0}">
            <div class="pos-a wd-100p ht-100p zindex-9 dp-flex jus-c font-50 cr-white fw">Terms of Use</div>
            <img class="wd-100p" :src="require('@/assets/termsofuse.jpg')" />
        </div>
        <div class="pd-20">
            <div class="mg-a max-wd-1000">
                <div class="cr-theme2 font-24 wb-keep">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum<br /><br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum<br /><br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum<br /><br />

                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                    culpa qui officia deserunt mollit anim id est laborum<br /><br />


                </div>
            </div>
        </div>
        <div class="ht-140"></div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
    components: {
        Header, Footer,
    },
    data() {
        return {
            showVirtual: false,
            isV: true, //滚动的方向 true 为垂直方向，false 为左右方向
        };
    },
    methods: {
        clickref(ref) {
            this.pushr(ref);
        },
    },
    created() {
    },
    computed: {
        mob() {
            return this.$store.state.mob;
        }
    },
    watch: {
    },
    beforeDestroy() { },
};
</script>